import { useMemo } from 'react';
import type { ModuleNavigationConfig, NavigationMenuItem } from '@/config/navigation.generated';
import { useVisibleNavigation } from './useVisibleNavigation';

/** The home dashboard: always a choice, and where a user lands without one. */
export const HOME_LANDING_PAGE = '/';

/**
 * Menu items flagged `landingPage` — from the entity DSL's `navigation.landingPage`, or set on a
 * hand-written item in navigation.custom.ts — in menu order, one per path.
 */
export function landingPageItems(modules: ModuleNavigationConfig[]): NavigationMenuItem[] {
  const byPath = new Map<string, NavigationMenuItem>();
  for (const item of modules.flatMap(m => m.categories.flatMap(c => c.items))) {
    if (item.landingPage && !byPath.has(item.path)) {
      byPath.set(item.path, item);
    }
  }
  return [...byPath.values()];
}

/** The landing pages the signed-in user may choose besides the home dashboard. */
export function useLandingPageItems(): NavigationMenuItem[] {
  const visible = useVisibleNavigation();
  return useMemo(() => landingPageItems(visible), [visible]);
}
